import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Recta/getComboRectaCalibrado`, method: 'GET', body: null})
}
